import { render } from "./AuthMenu.vue?vue&type=template&id=87df14b4"
import script from "./AuthMenu.vue?vue&type=script&lang=js"
export * from "./AuthMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__